/** Firestore paths — must match firestore.rules `privateChats` block. */
export const PRIVATE_CHATS_COLLECTION = 'privateChats';
export const MESSAGES_SUBCOLLECTION = 'messages';

/** Friendship doc id matches conversation id (sorted uids joined with `_`). */
export const FRIENDSHIPS_COLLECTION = 'friendships';

/** Max chars per message — client + rules (`text.size() <= 200`). */
export const MAX_MESSAGE_LENGTH = 200;

/** Max messages loaded per conversation subscription. */
export const PRIVATE_MESSAGE_QUERY_LIMIT = 200;

/** Min ms between sends per client (UI rate limit). */
export const RATE_LIMIT_MS = 2000;

/** Thrown by privateChatFirestore / client guards — map in errors.js */
export const PrivateChatErrorCode = {
  NOT_FRIENDS: 'NOT_FRIENDS',
  MESSAGING_BLOCKED: 'MESSAGING_BLOCKED',
};

export function chatReadStorageKey(uid) {
  return `lockedin_chat_read_${uid}`;
}
